import { PermissionsRiskLevelSummaryFieldsFragment } from '@api/gql/graphql';
import { RiskScore } from '@common/components/RiskScore';
import { calcRiskScoreSummary, RISK_LEVEL_ENUM } from '@common/utils/risk-score-helpers';
import { Stack, Typography } from '@mui/material';

interface RiskScoreSummaryProps {
  permissionsRiskLevelSummary: PermissionsRiskLevelSummaryFieldsFragment;
  resourceRiskLevel: string;
}

export function RiskScoreSummary({ permissionsRiskLevelSummary, resourceRiskLevel }: RiskScoreSummaryProps) {
  const { lowScoreCount, mediumScoreCount, highScoreCount } = calcRiskScoreSummary({
    summary: permissionsRiskLevelSummary,
    resourceRiskLevel,
  });

  return (
    <Stack direction="row" spacing={1}>
      <RiskScoreStack
        resourceRiskLevel={RISK_LEVEL_ENUM.high}
        permissionRiskLevel={RISK_LEVEL_ENUM.high}
        count={highScoreCount}
      />
      <RiskScoreStack
        resourceRiskLevel={RISK_LEVEL_ENUM.medium}
        permissionRiskLevel={RISK_LEVEL_ENUM.medium}
        count={mediumScoreCount}
      />
      <RiskScoreStack
        resourceRiskLevel={RISK_LEVEL_ENUM.low}
        permissionRiskLevel={RISK_LEVEL_ENUM.low}
        count={lowScoreCount}
      />
    </Stack>
  );
}

interface RiskScoreStackProps {
  resourceRiskLevel: string;
  permissionRiskLevel: string;
  count: number;
}

function RiskScoreStack({ resourceRiskLevel, permissionRiskLevel, count }: RiskScoreStackProps) {
  return (
    <Stack direction="row" spacing={0.5}>
      <RiskScore
        resourceRiskLevel={resourceRiskLevel}
        permissionRiskLevel={permissionRiskLevel}
        withRiskScore={false}
      />
      <Typography variant="body2" width={'20px'}>
        {count}
      </Typography>
    </Stack>
  );
}
